module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<textarea\n	data-column=\"")
    ; __append(escapeFn( column.name ))
    ; __append("\"\n	class=\"w100\"\n	on-change=\"onTextColumnChange\"\n	>\n    ")
    ; __append(escapeFn( widget.item[column.name] === undefined ? "" : widget.item[column.name] ))
    ; __append("\n</textarea>\n")
  }
  return __output.join("");

}